import { Link } from 'react-router-dom';

function WithLink({
  link,
  children,
  isExternalLink,
  wrapInsdieDiv = false,
  ...props
}) {
  if (!link) {
    if (!wrapInsdieDiv) {
      return <>{children}</>;
    } else {
      return <div {...props}>{children}</div>;
    }
  }

  if (isExternalLink) {
    return (
      <a rel='noreferrer' target='_blank' href={link} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link {...props} to={link}>
      {children}
    </Link>
  );
}

export default WithLink;
